export const SWITCH_ADVANCED = 'SWITCH_ADVANCED' // 高级筛选控制开关
export const FILTER_ADVANCED = 'FILTER_ADVANCED' // 高级筛选过滤条件
export const FILTER_NORMAL = 'FILTER_NORMAL' // 普通筛选过滤条件
export const SET_SORTOBJ = 'SET_SORTOBJ' // 排序条件
export const RESET = 'RESET' // 重置所有筛选条件
export const PURCHASE_TOTAL = 'PURCHASE_TOTAL' // 选择关联商品的总价
export const WAREHOUSE_ID = 'WAREHOUSE_ID' // 仓库id
export const INITLIST = 'INITLIST' // 列表页初始化
export const UPDATE_VUEXPAGE = 'UPDATE_VUEXPAGE' // 类表页码
export const INCREASE_SELECT = 'INCREASE_SELECT' // 增加选中产品
export const DECREASE_SELECT = 'DECREASE_SELECT' // 删除选中产品
export const UPDATE_SELECT = 'UPDATE_SELECT' // 更新选中产品
export const UPDATE_SELECTROWS = 'UPDATE_SELECTROWS' // 更新选中的行
export const SET_STAGE = 'SET_STAGE' // 更新销售阶段
export const SELECT_ALL = 'SELECT_ALL' // 全选
export const CANCEL_ALL = 'CANCEL_ALL' // 取消全选
export const ASYNC_VALIDATE = 'ASYNC_VALIDATE' // 自定义异步验证
export const UPDATE_REMINDCOUNT = 'UPDATE_REMINDCOUNT' // 更新消息提醒数
export const SUPPLIER_ID = 'SUPPLIER_ID_ID' // 供应商id
export const ERROR_CODE = 'ERROR_CODE' // 服务端返回的错误码
export const DETAIL_CONFIG = 'DETAIL_CONFIG' // 详情页权限配置
export const LIST_LOADING = 'LIST_LOADING' // 列表页的loading状态
export const RED_STATUS = 'RED_STATUS' // 红冲状态
export const SIDEMENU_STATUS = 'SIDEMENU_STATUS' // 左侧菜单固定状态
export const CTI_STATUS = 'CTI_STATUS' // 度言CTI 开启状态
export const REF_INFOS = 'REF_INFOS' // 度言CTI 客户信息
export const CTI_EMIT = 'CTI_EMIT' // 监听度言窗口的新建/查看事件
export const MODULE_TYPE = 'MODULE_TYPE' // 话务中心module类型
export const MODULE_TYPE_LIST = 'MODULE_TYPE_LIST' // 可供选择的话务中心module类型
export const CTI_ROLE = 'CTI_ROLE' // 话务中心角色
export const CTI_MODAL = 'CTI_MODAL' // 是否展开CTI弹窗
export const CTI_ACCOUNT = 'CTI_ACCOUNT' // 保存CTI登录信息
export const UPDATE_ADDRESS = 'UPDATE_ADDRESS' // address 组件更新
export const PRODUCT_NO = 'PRODUCT_NO' // 产品新建&编辑--产品编号
export const SPECIAL_ENMUS = 'SPECIAL_ENMUS' // 特殊的枚举类
export const UPDATE_PERFORMANCE_NAV = 'UPDATE_PERFORMANCE_NAV' // 业绩目标指标列表

export const ADD_PAYMENT_DATA = 'ADD_PAYMENT_DATA' // 新加的回款计划
export const EDIT_PAYMENT_DATA = 'EDIT_PAYMENT_DATA' // 已经有的回款计划
export const PAYMENT_NO_MAX = 'PAYMENT_NO_MAX' // 回款编号最大的尾缀
export const SET_PAYMENT_FORM = 'SET_PAYMENT_FORM' // 要提交的回款计划
export const CHECK_PAYMENT = 'CHECK_PAYMENT' // 是否对回款计划进行校验
export const SET_EDIT_PAYMENTMONEY = 'SET_EDIT_PAYMENTMONEY' // 已有回款计划的金额
export const INIT_PAYMENT = 'INIT_PAYMENT' // 初始化回款计划
export const SET_PAYMENT_TYPE = 'SET_PAYMENT_TYPE' // 初始化回款计划
export const UPDATE_ADDNUMINDEX = 'UPDATE_ADDNUMINDEX' // 更新扫码数量加1序号
export const SET_CONTACT_ARRAY = 'SET_CONTACT_ARRAY' // 设置已有联系人
export const SET_EXPLAINS = 'SET_EXPLAINS' // 联系人模板
export const OPEN_ADDNEW = 'OPEN_ADDNEW' // 添加联系人
export const SET_CONTACT_TYPE = 'SET_CONTACT_TYPE' // 添加联系人
export const INIT_CONTACT = 'INIT_CONTACT' // 添加联系人
export const MISS_CALL_COUNT = 'MISS_CALL_COUNT' // 未接来电数
export const SET_ALIAS_LIST = 'SET_ALIAS_LIST' // 菜单自定义
export const SET_FRESH_ALL_LIST = 'SET_FRESH_ALL_LIST' // 刷新列表页


// WEBPACK FOOTER //
// ./src/store/mutation-types.js